module.exports = __webpack_public_path__ + "static/media/ebb-logo.649caa1e.svg";